var PresentersBase;

PresentersBase = {
  getI18n: function(I18nScope) {
    var scope;
    scope = I18nScope;
    if (scope != null) {
      return I18n.scoped(scope);
    } else {
      return I18n;
    }
  },
  toHashWithHelpers: function(hash, I18nScope) {
    var presenterHash;
    presenterHash = _.clone(hash);
    return I18n.mixin(presenterHash, this.getI18n(I18nScope));
  }
};

module.exports = PresentersBase;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL2JhY2tib25lX2Jhc2UvZnJvbnRlbmQvcHJlc2VudGVycy9iYXNlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9iYWNrYm9uZV9iYXNlL2Zyb250ZW5kL3ByZXNlbnRlcnMvYmFzZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLEdBQ0U7RUFBQSxPQUFBLEVBQVMsU0FBQyxTQUFEO0FBQ1AsUUFBQTtJQUFBLEtBQUEsR0FBUTtJQUNSLElBQUcsYUFBSDthQUNFLElBQUksQ0FBQyxNQUFMLENBQVksS0FBWixFQURGO0tBQUEsTUFBQTthQUdFLEtBSEY7O0VBRk8sQ0FBVDtFQU9BLGlCQUFBLEVBQW1CLFNBQUMsSUFBRCxFQUFPLFNBQVA7QUFDakIsUUFBQTtJQUFBLGFBQUEsR0FBZ0IsQ0FBQyxDQUFDLEtBQUYsQ0FBUSxJQUFSO1dBQ2hCLElBQUksQ0FBQyxLQUFMLENBQVcsYUFBWCxFQUEwQixJQUFDLENBQUEsT0FBRCxDQUFTLFNBQVQsQ0FBMUI7RUFGaUIsQ0FQbkI7OztBQVdGLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
